<template>
    <edit-selection
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('tax_year')"
        :items="items"
        :autocomplete="false"
    />
</template>

<script>
import BaseField from './BaseField';
import getTaxYears from '@/lib/helpers/getTaxYears';

export default {
    name: 'TaxYear',
    extends: BaseField,
    props: {
        allowAll: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        items() {
            let items = getTaxYears(1994, 'value', 'text');

            if (this.allowAll) {
                items = [{ value: null, text: `${this.$t('all')} ${this.$t('tax_years')}` }, ...items];
            }

            return items;
        }
    }
};
</script>
